{
    "UserNotificationBusyTime": "Ricevete una notifica quando il vostro team è occupato.",
    "UserNotificationMissedCalls": "Ricevere una notifica quando si perde un determinato numero di chiamate nell'arco di 60 minuti.",
    "UserNotificationWeeklyInsightsReport": "Ricevere un rapporto settimanale sulle prestazioni.",
    "UserNotificationUserNotLoggedIn7Days": "Ricevere una notifica quando non si effettua l'accesso per 7 giorni.",
    "UserNotificationAvgAnswerTime": "Ricevere una notifica quando il tempo medio di risposta supera un determinato numero di secondi a intervalli di mezz'ora.",
    "UserNotificationUserNeverLoggedIn": "Ricevere una notifica quando non si effettua l'accesso.",
    "NAME": "UserNotificationTypesHelp"
}